function compareFunction(a:any, b:any) {
    if (a < b ) {
      return -1;
    }
    if (a > b) {
      return 1;
    }

    return 0;
  }

export const getData = (data: any): any[] => {
    let nestedData: any = [];
    let singleData: any = [];
    let sortedSingleData:any=[];
    let sortedNestedData:any=[];
    data && data?.map((item: any) => {
        if (item?.data?.length > 0) {
            nestedData?.push(item)
        }
        else {
            singleData?.push(item)
        }
    })


    
         sortedSingleData=singleData?.sort((a:any,b:any)=> compareFunction(a?.ledger_name?.toLowerCase(),b?.ledger_name?.toLowerCase()) );
         sortedNestedData=nestedData?.sort((a:any,b:any)=>compareFunction(a?.ledger_name?.toLowerCase(),b?.ledger_name?.toLowerCase()) );
    


    return [...sortedSingleData, ...sortedNestedData]
}